exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".stat-title{font-size:14px;font-weight:550;margin-bottom:0;line-height:.9rem;opacity:1;color:rgba(0,0,0,.6)}.stat-text{font-size:14px;font-weight:400;opacity:1;color:#000;word-break:break-word}.info-heder{font-size:18px;font-weight:normal;color:#1574b0}.warning-message{font-size:17px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Product/SharedComponents/SubComponents/RequestSummary.scss
// module id = 1808
// module chunks = 101